import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { PenTool } from "react-feather";

//Forms
import UpdateContactForm from "./UpdateContactForm";

interface UpdateModalProps {
  id?: number;
  modal: boolean;
  toggle?: () => void;
}

const UpdateContactModal: React.FC<UpdateModalProps> = ({
  id,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Contact Record</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>
          <UpdateContactForm toggle={toggle} id={id} />
        </div>
      </Modal>
    </>
  );
};
export default UpdateContactModal;
